import MaintenanceMessage from './MaintenanceMessage'

export default MaintenanceMessage
